(function () {
  'use strict';

  /* @ngdoc object
   * @name shared
   * @description
   *
   */
  angular
    .module('itecAdministracio.shared', [
      'itecAdministracio.shared.breadcrumb',
      'itecAdministracio.shared.headerSubmenu',
      'itecAdministracio.shared.filters',
      'itecAdministracio.shared.submain',
      'itecAdministracio.shared.locale',
      'itecAdministracio.shared.tables',
      'itecAdministracio.shared.document'
    ]);
}());
